import React from 'react';
import styled from 'styled-components';

import { useModal } from '../../Providers/ModalContext';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const ListContainer = styled.ul`
  text-transform: ${({ $textTransform = 'uppercase' }) => $textTransform};
`;

const ListItem = styled.li`
  position: relative;
  font-size: ${({ $textSize = '1rem' }) => $textSize};
  margin-bottom: ${({ $marginBottom = '1rem' }) => $marginBottom};
  cursor: ${({ $cursor = 'text' }) => $cursor};
  padding-left: 35px;

  &::before {
    content: '•';
    position: absolute;
    top: 0;
    left: 10px;
  }

  &:last-child {
    margin-bottom: 0px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: ${({ $textMobile = '1rem' }) => $textMobile} !important;
  }
`;

const List = ({
  dataList,
  textSize,
  marginBottom,
  textTransform,
  cursor,
  textMobile,
}) => {
  const { openModal } = useModal();

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  return (
    <>
      <ListContainer $textTransform={textTransform}>
        {dataList?.map((list, key) => (
          <ListItem
            key={key}
            $textSize={textSize}
            $marginBottom={marginBottom}
            $cursor={cursor}
            $textMobile={textMobile}
            data-target={list.dataTarget}
            {...(list.click && { onClick: handleClick })}
          >
            <span>{list.text}</span>
          </ListItem>
        ))}
      </ListContainer>
    </>
  );
};

export default List;
